import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=b88270aa&scoped=true&"
import script from "./TagModal.vue?vue&type=script&lang=ts&"
export * from "./TagModal.vue?vue&type=script&lang=ts&"
import style0 from "./TagModal.vue?vue&type=style&index=0&id=b88270aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88270aa",
  null
  
)

export default component.exports